import { Field, TextInput } from "@/shared/foundation/primitives";

import styles from "./parameterForms.module.css";
import { useParameterRecord } from "./parameterValues";

export interface TextParameterProps {
  name: string;
  parameterKey: string;
  label: string;
  description?: string;
  /** The action's default, shown as the placeholder and never written. */
  placeholder?: string;
  mono?: boolean;
}

/** A free-text parameter; cleared, it falls back to the action's default. */
export function TextParameter({
  name,
  parameterKey,
  label,
  description,
  placeholder,
  mono = false,
}: TextParameterProps) {
  const record = useParameterRecord(name);
  const error = record.error(parameterKey);
  return (
    <Field.Root
      data-testid={`param-${parameterKey}`}
      invalid={error !== undefined}
    >
      <Field.Label>{label}</Field.Label>
      <Field.Control
        render={
          <TextInput
            spellCheck={false}
            size="lg"
            className={mono ? styles.mono : undefined}
          />
        }
        value={record.get(parameterKey) ?? ""}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          record.write({ [parameterKey]: event.target.value });
        }}
        placeholder={placeholder}
      />
      {description !== undefined && (
        <Field.Description>{description}</Field.Description>
      )}
      <Field.Error match>{error}</Field.Error>
    </Field.Root>
  );
}

/** The dataset tag an ingestion adds when it succeeds. */
export function TagOnSuccessField({
  name,
  defaultTag,
}: {
  name: string;
  defaultTag: string | undefined;
}) {
  return (
    <TextParameter
      name={name}
      parameterKey="INGESTED_TAG"
      label="Tag the dataset when ingestion succeeds"
      placeholder={defaultTag}
    />
  );
}
